<template>
  <div class="bootscreen_attendance_main">
    <!-- <div class="signbuttoncontent">
      <van-field v-model="cardNumber" placeholder="请输入卡号" />
      <van-button type="primary" @click="clickScanCard">签到</van-button>
    </div> -->
    <signin-logo></signin-logo>
    <div class="signin_content">
      <div class="content_box">
        <signin-header
          ref="signInHeader"
          :courseInfo="courseInfo.arrange"
        ></signin-header>
        <signin-enter
          ref="signInEnter"
          :attendType="courseInfo.attendType"
          :attendInfo.sync="attendInfo"
          :addressInfo="addressInfo"
          :currentAddress="courseInfo.arrange.place"
        ></signin-enter>
        <signin-case
          ref="signInCase"
          :classNameSet="
            courseInfo.arrange && courseInfo.arrange.classNames
              ? courseInfo.arrange.classNames
              : []
          "
        ></signin-case>
      </div>
    </div>
  </div>
</template>

<script>
import SigninHeader from "./components/SigninHeader.vue";
import SigninEnter from "./components/SigninEnter.vue";
import SigninCase from "./components/SigninCase.vue";
import SigninLogo from "./components/SigninLogo.vue";
// 考勤
export default {
  components: {
    SigninHeader,
    SigninEnter,
    SigninCase,
    SigninLogo,
  },
  data() {
    return {
      attendInfo: {},
      addressInfo: {},
      courseInfo: {
        arrange: {
          classNames: [],
          place: "",
        },
        attendType: "1",
      }, //课程详情
      outTimer: null,
      refreshQrCodeTimer: null,
      signInDetailTimer: null,
      cardNumber:"",
    };
  },
  watch: {
    $route(to, from) {
      if (
        to.path == from.path &&
        from.path == "/mobile/bootScreen/attendance"
      ) {
        this.getCourseDetail();
        this.$refs.signInCase.getSignCondition();
      }
    },
  },
  mounted() {
    window.swipingCardFunction = this.swipingCardFunction;
    this.getCourseDetail();
  },
  beforeDestroy() {
    if (this.outTimer) {
      clearTimeout(this.outTimer);
    }
    if (this.refreshQrCodeTimer) {
      clearInterval(this.refreshQrCodeTimer);
    }
    if (this.signInDetailTimer) {
      clearInterval(this.signInDetailTimer);
    }
    if (this.$refs.signInEnter.clearSignInfoTimer) {
      clearTimeout(this.$refs.signInEnter.clearSignInfoTimer);
    }
    if (this.$refs.signInEnter.timer) {
      clearTimeout(this.$refs.signInEnter.timer);
    }
  },
  methods: {
    //查询课程详情信息
    getCourseDetail() {
      this.attendInfo = {};
      if (this.outTimer) {
        clearTimeout(this.outTimer);
      }
      if (this.refreshQrCodeTimer) {
        clearInterval(this.refreshQrCodeTimer);
      }
      if (this.signInDetailTimer) {
        clearInterval(this.signInDetailTimer);
      }
      if (this.$refs.signInEnter.clearSignInfoTimer) {
        clearTimeout(this.$refs.signInEnter.clearSignInfoTimer);
      }
      if (this.$refs.signInEnter.timer) {
        clearTimeout(this.$refs.signInEnter.timer);
      }
      if (this.$refs.signInHeader.DetailsDialog) {
        this.$refs.signInHeader.DetailsDialog = false;
      }
      if (this.$refs.signInEnter.show) {
        this.$refs.signInEnter.show = false;
      }
      if (this.$refs.signInCase.DetailsDialog) {
        this.$refs.signInCase.DetailsDialog = false;
      }
      let loading = dsf.layer.loading();
      let _this = this;
      this.$http
        .get(
          "/teas/screen/attendDetails",
          {
            id: this.$route.query.id || "", //事项id
            relId: this.$route.query.relId || "", //事项为课程时的考勤业务id
            courseNoonId: this.$route.query.courseNoonId || "", //事项为课程时的排课午别id
            type: this.$route.query.type || "", //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          dsf.layer.closeLoading(loading);
          if (success) {
            _this.courseInfo = data;
            if (
              data.arrange &&
              data.arrange.attendEndDate &&
              data.arrange.attendEndDate.length > 0
            ) {
              let currentTime = new Date().getTime();
              let endTime = new Date(data.arrange.attendEndDate).getTime();
              let timeIntervalNumber = endTime - currentTime + 3000;
              let tempThis = _this;
              _this.outTimer = setTimeout(() => {
                tempThis.$router.back();
              }, timeIntervalNumber);
            }
            if (data.attendType && data.attendType.indexOf("3") > -1) {
              _this.requestRefreshQrcodeInfo();
              let tempThis = _this;
              _this.signInDetailTimer = setInterval(() => {
                tempThis.$refs.signInCase.getSignCondition();
              }, 2000);
            }
            if (
              _this.$route.query.needSignIn &&
              _this.$route.query.needSignIn == 1
            ) {
              _this.swipingCardFunction(
                _this.$route.query.cardId,
                _this.$route.query.faceInfo
              );
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.closeLoading(loading);
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    requestRefreshQrcodeInfo(){
      let _this = this;
      this.$http
        .get(
          "/teas/attendance/getSystemQrCodeConfig",
          {},
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success && data.codeRefreshValue && data.codeRefreshValue == 1) {
            let tempTime = parseInt(data.refreshSecond);
            if(tempTime > 0){
              let tempThis = _this;
              _this.refreshQrCodeTimer = setInterval(() => {
                tempThis.$refs.signInEnter.refreshQrCodeFunction();
              }, tempTime * 1000);
            }
          }
        })
        .error((err) => {

        });
    },
    //刷卡调用方法
    swipingCardFunction(cardId, faceInfo) {
      let _this = this;
      this.$http
        .post(
          "/teas/screen/signIn",
          {
            id: this.$route.query.id || "", //事项id
            relId: this.$route.query.relId || "", //事项为课程时的考勤业务id
            type: this.$route.query.type || "", //事项类型值
            attendMode: this.$route.query.attendMode || "", //事项为课程时的考勤模式
            cardId: cardId || "",
            faceInfo: faceInfo || "",
            equipmentId: sessionStorage.getItem("equipmentId") || "",
          },
          {},
          $$webRoot.default
        )
        .done(({ success, data, message }) => {
          if (success) {
            if (!dsf.isEmptyObject(_this.attendInfo)) {
              _this.attendInfo = {};
            }
            if (_this.$refs.signInHeader.DetailsDialog) {
              _this.$refs.signInHeader.DetailsDialog = false;
            }
            if (_this.$refs.signInEnter.show) {
              _this.$refs.signInEnter.show = false;
            }
            if (_this.$refs.signInCase.DetailsDialog) {
              _this.$refs.signInCase.DetailsDialog = false;
            }
            let code =
              data.signMessage && data.signMessage.errorCode
                ? data.signMessage.errorCode
                : 0;
            switch (code) {
              case 30001: {
                _this.attendInfo = data.signMessage || {};
                this.$refs.signInCase.getSignCondition();
                break;
              }
              case 30002: {
                _this.attendInfo = data.signMessage || {};
                break;
              }
              case 30003: {
                _this.attendInfo = data.signMessage || {};
                break;
              }
              case 30004: {
                _this.addressInfo = data.jumpArrange || {};
                _this.attendInfo = data.signMessage || {};
                break;
              }
              case 30005: {
                _this.attendInfo = data.signMessage || {};
                break;
              }
              case 30006: {
                //跳转课程
                let tempObject = data.currentArrange || {};
                var url =
                  "/mobile/bootScreen/attendance?id=" +
                  tempObject["id"] +
                  "&relId=" +
                  tempObject["relId"] +
                  "&courseNoonId=" +
                  tempObject["courseNoonId"] +
                  "&type=" +
                  tempObject["typeValue"] +
                  "&attendMode=" +
                  tempObject["courseAttendMode"] +
                  "&cardId=" +
                  cardId +
                  "&faceInfo=" +
                  faceInfo +
                  "&needSignIn=1";
                _this.$router.replace({
                  path: url,
                });
                break;
              }
              default:
                break;
            }
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    clickScanCard(){
      window.swipingCardFunction(this.cardNumber , "");
    }
  },
};
</script>

<style scoped>
.signbuttoncontent{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
}
</style>